import { Typography } from "@mui/material";
import { UseFormGetValues } from "react-hook-form";
import {formatPhoneNumberIntl} from "@/utils/formatPhoneNumberIntl.ts";

interface IProps {
  getValues: UseFormGetValues<ICheckoutForm>;
}

const FirstStepSummary: React.FC<IProps> = ({ getValues }) => {
  const name = `${getValues().firstName} ${getValues().lastName}`;
  return (
    <>
      <Typography
        color="text.secondary"
        variant="subtitle1"
        fontWeight={{ xs: 500, md: 600 }}
      >
        {name}
      </Typography>
        <Typography
            color="text.secondary"
            variant="subtitle1"
            fontWeight={{ xs: 500, md: 600 }}
        >
            {getValues().email}
        </Typography>
      <Typography
        color="text.secondary"
        variant="subtitle1"
        fontWeight={{ xs: 500, md: 600 }}
      >
        {getValues().streetAddress}  {getValues().city}
      </Typography>
      <Typography
        color="text.secondary"
        variant="subtitle1"
        fontWeight={{ xs: 500, md: 600 }}
      >
        {getValues().zipCode}
      </Typography>
      <Typography
        variant="subtitle1"
        color="text.secondary"
        fontWeight={{ xs: 500, md: 600 }}
      >
        {formatPhoneNumberIntl(getValues().phoneNumber)}
      </Typography>
    </>
  );
};

export default FirstStepSummary;
